export var createConnectedNativeAudioBufferSourceNodeFactory = function createConnectedNativeAudioBufferSourceNodeFactory(createNativeAudioBufferSourceNode) {
  return function (nativeContext, nativeAudioNode) {
    var nativeAudioBufferSourceNode = createNativeAudioBufferSourceNode(nativeContext);
    var nativeAudioBuffer = nativeContext.createBuffer(1, 2, nativeContext.sampleRate);
    nativeAudioBufferSourceNode.buffer = nativeAudioBuffer;
    nativeAudioBufferSourceNode.loop = true;
    nativeAudioBufferSourceNode.connect(nativeAudioNode);
    nativeAudioBufferSourceNode.start();
    return function () {
      nativeAudioBufferSourceNode.stop();
      nativeAudioBufferSourceNode.disconnect(nativeAudioNode);
    };
  };
};